module.exports = __webpack_public_path__ + "img/title.16be13e2.png";